import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Portal } from 'react-portal';
import { useSpring, animated, useChain } from 'react-spring';
import _ from 'lodash';

import { buttonsV2 as ButtonsV2 } from '@breezeway/brzw-components';

import './cell_modal_popup.scss';

const CLASS_NAME = 'cell-modal';

const CellModalPopup = ({ isOpen, content, toggle, cellDate, position, lastRow }) => {
  const opacity = {
    config: { mass: 5, tension: 350, friction: 40, duration: 100 },
    opacity: isOpen ? 1 : 0,
  };

  const springRef = useRef();
  const propsSpring = useSpring({ ...opacity, ref: springRef });
  useChain([springRef]);

  const modalDomPosition = document.getElementById('cell-modal');
  const weekDay = _.invoke(cellDate, 'format', 'ddd');

  return (
    isOpen && (
      <Portal node={modalDomPosition}>
        <div
          className={classnames(`${CLASS_NAME}__wrapper`, { '-last-row': lastRow })}
          style={position}
        >
          <animated.div
            style={propsSpring}
            className={classnames(CLASS_NAME, { '-show': !_.isEmpty(content) })}
          >
            <div className={`${CLASS_NAME}__header`}>
              <div className={`${CLASS_NAME}__week-day`}>{weekDay}</div>
              <ButtonsV2.IconButton
                className={`${CLASS_NAME}__close`}
                iconName="close"
                onClick={toggle}
                size={ButtonsV2.constants.BUTTON_SIZES.ICON_MEDIUM}
                theme={ButtonsV2.constants.BUTTON_THEMES.ICON_SUBTLE}
              />
            </div>

            {content && (
              <div className={`${CLASS_NAME}__body brzw-calendar-container--theme-third`}>
                {content}
              </div>
            )}
          </animated.div>
        </div>
      </Portal>
    )
  );
};

CellModalPopup.propTypes = {
  cellDate: PropTypes.shape({}),
  content: PropTypes.node,
  isOpen: PropTypes.bool,
  lastRow: PropTypes.bool,
  position: PropTypes.shape({}),
  toggle: PropTypes.func,
};

export default CellModalPopup;
